// getShouldShowLivestreamCta.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getMeData from '../selector/getMeData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getOperationData from '../selector/getOperationData.js';

import {
  PRESET_SD,
  PRESET_PREVIEW,
  privateShowStatus as privateShowStatusConstant,
} from '../resource/liveStreamConstants.js';

/**
 * Select Get should show livestream cta by stream id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - stream id.
 * @return {boolean} Return true if cta button should show.
 */
const getShouldShowLivestreamCta = createCachedSelector(
  state => getMeData(state, 'id'),
  (state, streamId) => getPrivateShowStatus(state, streamId),
  (state, streamId) => getLiveStreamData(state, [streamId], 'status'),
  (state, streamId) =>
    getLiveStreamData(state, [streamId, 'privateShow'], 'fundingId'),
  (state, streamId) =>
    getLiveStreamData(state, [streamId, 'presets', PRESET_SD], 'nbf'),
  (state, streamId) =>
    getLiveStreamData(
      state,
      [streamId, 'presets', PRESET_SD, 'counter'],
      'nbf'
    ),
  (state, streamId) =>
    getLiveStreamData(
      state,
      [streamId, 'presets', PRESET_SD, 'counter'],
      'exp'
    ),
  (state, streamId) =>
    getOperationData(state, ['liveStream', 'paid', streamId], 'streamToken'),
  (state, streamId) =>
    getOperationData(
      state,
      ['liveStream', 'paid', streamId],
      'isPrivateStreamUnlocked'
    ),
  (
    meId,
    privateShowStatus,
    streamStatus,
    fundingId,
    sdNbf,
    privateStreamCounterNbf,
    privateStreamCounterExp,
    streamToken,
    isPrivateStreamUnlocked
  ) => {
    const isAuthed = !!meId;
    const hasStreamToken = !!streamToken;
    const isScheduledPrivateLiveStream = !!sdNbf;
    const canUnlockStreamInShowStatus = [
      privateShowStatusConstant.FUNDING,
      privateShowStatusConstant.FUNDING_FINAL_CALL,
      privateShowStatusConstant.CONSIDERING,
    ].includes(privateShowStatus);
    if (!isAuthed) return true;
    if (
      PRESET_SD === streamStatus &&
      !hasStreamToken &&
      !isPrivateStreamUnlocked &&
      (canUnlockStreamInShowStatus || !fundingId)
    )
      return true;
    if (
      PRESET_PREVIEW === streamStatus &&
      !fundingId &&
      !hasStreamToken &&
      !isPrivateStreamUnlocked &&
      (isScheduledPrivateLiveStream ||
        (!!privateStreamCounterNbf && !!privateStreamCounterExp))
    )
      return true;
    return false;
  }
)((state, streamId) => `${streamId}`);

export default getShouldShowLivestreamCta;
